// extracted by mini-css-extract-plugin
export var alternateTextStyle = "style-mod--alternate-text-style--37049";
export var customServiceModal = "style-mod--custom-service-modal--42dc2";
export var customerCookwareBody = "style-mod--customer-cookware-body--ac98f";
export var customerCookwareContent = "style-mod--customer-cookware-content--a5e49";
export var customerCookwareImage = "style-mod--customer-cookware-image--0b071";
export var customerCookwareImageCover = "style-mod--customer-cookware-image-cover--4157c";
export var customerCookwareImageDesktop = "style-mod--customer-cookware-image-desktop--6ed63";
export var customerCookwareImageMobile = "style-mod--customer-cookware-image-mobile--88444";
export var customerCookwareParagraph = "style-mod--customer-cookware-paragraph--d87c0";
export var customerCookwareText = "style-mod--customer-cookware-text--dea23";
export var customerCookwareTextImage = "style-mod--customer-cookware-text-image--3b72b";
export var customerCookwareTitle = "style-mod--customer-cookware-title--99696";
export var modalClose = "style-mod--modal-close--ecbdd";
export var modalCloseContainer = "style-mod--modal-close-container--1a5ed";
export var modalCloseDesktop = "style-mod--modal-close-desktop--e7350";
export var modalCloseDesktopDesktop = "style-mod--modal-close-desktop-desktop--6ac62";
export var modalCloseDesktopResponsive = "style-mod--modal-close-desktop-responsive--80066";
export var modalCloseResponsive = "style-mod--modal-close-responsive--22201";
export var modalParagraph = "style-mod--modal-paragraph--f84b2";
export var modalTitle = "style-mod--modal-title--3feb8";